import {FieldEvent} from './settings';
import {DateTime} from '../../common/fields/time';
import {fieldArts as arts} from '../../artjs/field';
import {$hfsDatePicker} from '../../../../date';

export function createTIME(d) {
  FieldEvent[d.fieldName] = new DateTime(d);
  return FieldEvent[d.fieldName];
}

export function renderTIME(d){
  const field = FieldEvent[d];
  if(!field.dom){
    field.dom = document.getElementById(`sk-field-${d}`);
  }
  if(field.dom){
    field.dom.innerHTML = arts.FIELDTIME.pc({field: field});
  }
}


export function changeTIME(e, d) {
  const field = FieldEvent[d];
  $hfsDatePicker({
    elem: e,
    format: field.format,
    model: field.model
  }, (o) => {
    field.setValue(o.model);
    renderTIME(d);
  });
}

